module.exports = __webpack_public_path__ + "static/media/1.845b7bbe.png";